module.exports = __webpack_public_path__ + "static/1140366488.82e70e55.jpg";